import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import SharedGPAPlanner from "./SharedGPAPlanner";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from "../../../images/StudyCalculatorImg.webp";

const TITLE = "Rencanakan IPK Kuliah Anda Secara Efektif";
const DESCRIPTION =
  "Cari tahu cara merencanakan IPK kuliah Anda secara efektif. Pelajari strategi terbaik untuk meningkatkan dan merencanakan IPK guna meraih kesuksesan akademik.";
const KEYWORDS =
  "perencanaan IPK, strategi perencanaan IPK, meningkatkan IPK, kesuksesan akademik";
const OG_URL = "https://do-calculate.com/calculator/id/gpaplanner";

function GPAPlanner() {
  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <SharedGPAPlanner />
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>{" "}
                  </u>
                  <p>
                    Setiap mahasiswa memiliki gaya belajar masing-masing. Beberapa orang lebih suka bekerja berjam-jam tanpa henti untuk menyelesaikan tugas tertentu, sementara yang lain mungkin mengambil beberapa kali istirahat. Tidak ada strategi yang sempurna untuk semua orang, dan cara seseorang mendekati proses pembelajaran sangat bergantung pada gaya belajarnya, serta komitmennya terhadap strategi belajar yang sesuai dengan jadwal dan keinginannya. Cara yang paling meningkatkan nilai waktu yang digunakan cenderung menjadi yang paling efektif dalam meningkatkan proses pembelajaran dan pada akhirnya meningkatkan IPK.
                  </p>
                  <p>
                    Selain itu, pengorganisasian tugas yang harus dilakukan, serta catatan yang diambil, juga penting. Penting untuk dapat menemukan informasi yang relevan sama halnya dengan saat mencatat di kelas. Catatan menjadi sangat berharga ketika dapat digunakan untuk mendukung proses pembelajaran. Dosen menyampaikan banyak informasi selama kuliah, tidak serta merta mahasiswa dapat memproses semuanya dalam waktu singkat. Oleh karena itu, penting untuk berlatih mencatat dengan cara yang memungkinkan mahasiswa untuk merujuk kembali dan mencari informasi tersebut nanti.
                  </p>
                  <p>
                    Manajemen waktu juga merupakan bagian penting dari perencanaan. Hanya ada 24 jam dalam sehari, dan seseorang tidak dapat menggunakannya secara produktif semuanya. Meskipun belajar itu penting, mengambil terlalu banyak kursus atau berpartisipasi dalam kegiatan di luar kemampuan dapat merugikan proses pembelajaran dan IPK. Setelah semua kursus ditentukan, mengalokasikan waktu untuk setiap kursus dapat membantu menempatkan jumlah pekerjaan dan waktu yang diperlukan ke dalam perspektif yang benar. Meskipun jumlah pekerjaan yang diperlukan untuk sejumlah kursus mungkin tampak berat pada awalnya, merencanakan bagaimana dan kapan mengerjakan setiap kursus dapat membantu mengurangi stres dan meningkatkan efisiensi setelah jumlah pekerjaan ditentukan (atau dapat membantu seseorang menyadari bahwa mereka menghadapi masalah yang lebih besar dari yang mampu mereka tangani).
                  </p>
                  <p>
                    Meninjau pekerjaan secara teratur, dalam konteks belajar, adalah aspek lain dari manajemen waktu. Sejumlah besar informasi dibahas dalam suatu kursus menjelang ujian akhir, dan meninjau beberapa informasi secara teratur dari waktu ke waktu seringkali lebih efektif daripada mencoba menghafal semua informasi sebelum ujian. Mempelajari informasi melalui peninjauan berkala pada akhirnya dapat menghemat lebih banyak waktu dan memungkinkan seseorang untuk berkinerja lebih baik dalam ujian, sehingga meningkatkan IPK.
                  </p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GPAPlanner;